import { ReunionIcon } from "@logora/parliament.icons.regular_icons";
import { BooleanField } from "../components/BooleanField";
import {
	capitalizeFirstLetter,
	formatBooleen,
	formatCell,
	formatChambre,
	formatDate,
	formatRow,
} from "../formatters";
import { EtatLabel } from "../reunions/EtatLabel";
const formatMotif = (info) => {
	const item = info.row.original;

	return capitalizeFirstLetter(
		item.objet || item.compteRenduRef?.quantiemesJournee,
	);
};

const formatCompteRendu = (value) => {
	return <BooleanField condition={value !== null} />;
};

export const formatEtat = (item) => {
	if (!item.etat) return null;

	return <EtatLabel etat={item.etat} />;
};

const columns = [
	{
		header: "Chambre",
		accessorKey: "chambre",
		cell: (info) => formatChambre(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Chambre",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{
						value: "AN",
						label: "AN",
					},
					{
						value: "SN",
						label: "SN",
					},
				],
			},
		},
	},
	{
		header: "Organe",
		isVisible: false,
		meta: {
			filter: {
				label: "Organe",
				variant: "select",
				key: "organeReunionRef_type",
				options: [
					{ value: null, label: "Tous" },
					{ value: "Circonscription", label: "Circonscription" },
					{ value: "Groupe politique", label: "Groupe politique" },
					{
						value: "Commission permanente",
						label: "Commission permanente",
					},
					{
						value: "Commission d'enquête",
						label: "Commission d'enquête",
					},
					{
						value: "Commission spéciale",
						label: "Commission spéciale",
					},
					{ value: "Délégation", label: "Délégation" },
					{
						value: "Mission d'information",
						label: "Mission d'information",
					},
					{
						value: "Commission mixte paritaire",
						label: "Commission mixte paritaire",
					},
					{ value: "Groupe d'amitié", label: "Groupe d'amitié" },
					{ value: "Groupe d'étude", label: "Groupe d'étude" },
					{
						value: "Office parlementaire",
						label: "Office parlementaire",
					},
					{ value: "Institution", label: "Institution" },
					{ value: "Ministère", label: "Ministère" },
					{ value: "Gouvernement", label: "Gouvernement" },
					{ value: "Organe politique", label: "Organe politique" },
					{ value: "Organe externe", label: "Organe externe" },
					{
						value: "Autorité administrative indépendante",
						label: "Autorité administrative indépendante",
					},
					{ value: "Assemblée", label: "Assemblée" },
					{ value: "Sénat", label: "Sénat" },
					{ value: "Parti politique", label: "Parti politique" },
				],
			},
		},
	},
	{
		header: "Date",
		accessorKey: "timestampDebut",
		cell: (info) => formatDate(formatCell(info)),
		defaultSorting: "desc",
		meta: {
			filter: {
				label: "Date",
				variant: "date-range",
				labels: ["Après le", "Avant le"],
			},
		},
	},
	{
		header: "Organe",
		accessorKey: "organeReunionRef.libelle",
		enableSorting: false,
	},
	{
		header: "Motif de la réunion",
		accessorKey: "motif",
		cell: (info) => formatMotif(info),
		enableSorting: false,
	},
	{
		header: "Nombre de participants",
		accessorKey: "nombreParticipants",
	},
	{
		header: "Compte-rendu",
		accessorKey: "compteRenduDisponible",
		cell: (info) => formatBooleen(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Compte-rendu",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{ value: true, label: "Disponible" },
					{ value: false, label: "Non disponible" },
				],
			},
		},
	},
	{
		header: "État",
		accessorKey: "etat",
		cell: (info) => formatEtat(formatRow(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "État",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{ value: "Terminé", label: "Terminé" },
					{ value: "À venir", label: "À venir" },
					{ value: "Eventuel", label: "Éventuel" },
					{ value: "Annulé", label: "Annulé" },
					{ value: "Supprimé", label: "Supprimé" },
				],
			},
		},
	},
	{
		header: "Vidéo",
		accessorKey: "captationVideo",
		cell: (info) => formatBooleen(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Vidéo",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{ value: true, label: "Oui" },
					{ value: false, label: "Non" },
				],
			},
		},
	},
];

export const reunionDataset = {
	key: "reunions",
	name: "Réunions",
	columns: columns,
	filterMapping: { organeRefUid: "organeReunionRefUid" },
	include: ["organeReunionRef", "compteRenduRef"],
	icon: <ReunionIcon width={20} height={20} />,
};
